import axios from "axios";

const module = 'roles/permissions'

const state = {
    permissions:[]
}

const getters = {
    getPermissions: state => {
        return state.permissions
    },
}

const actions = {

    getList : async (context,payload) => {

        let url = `${module}`;

        return await axios.get(`${context.rootGetters['settings/getUrl']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)

            if(error.response && error.response.data){
                return error.response.data
            }else if(error.message){
                return error.message
            }else {
                return error;
            }
        });

    },
    getListByProfile : async (context,payload) => {

        let url = `${module}-by-profile`;

        return await axios.get(`${context.rootGetters['settings/getUrl']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)

            if(error.response && error.response.data){
                return error.response.data
            }else if(error.message){
                return error.message
            }else {
                return error;
            }
        });

    },
    permissionList : async (context,payload) => {

        let url = `${module}/${payload.id}`;

        return await axios.get(`${context.rootGetters['settings/getUrl']}${url}`,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            context.commit('setPermissions', result.data.result.permissions)
            return result.data.result.permissions

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)

            if(error.response && error.response.data){
                return error.response.data
            }else if(error.message){
                return error.message
            }else {
                return error;
            }
        });

    },
    permissionUpdate : async (context,payload) => {

        let url = `${module}/update`;

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`,payload,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)

            if(error.response && error.response.data){
                return error.response.data
            }else if(error.message){
                return error.message
            }else {
                return error;
            }
        });

    },

    permissionUpdateByProfile : async (context,payload) => {

        let url = `${module}/update-by-profile`;

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`,payload,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)

            if(error.response && error.response.data){
                return error.response.data
            }else if(error.message){
                return error.message
            }else {
                return error;
            }
        });

    },
}

const mutations = {
    setPermissions: (state, value) => {
        state.permissions = value
    },
}


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}

